import { AxiosRequestConfig, Method } from 'axios';

import axiosInstance from './axios';

interface RequestParams {
  method: Method;
  url: string;
  data?: unknown;
  contentType?: string;
  config?: AxiosRequestConfig;
}

const apiRequest = async <T>({ method, url, data = null, contentType, config = {} }: RequestParams): Promise<T> => {
  // Set 'Content-Type' if provided, otherwise default to 'application/json' for certain methods
  if (!config.headers) {
    config.headers = {};
  }

  if (contentType) {
    config.headers['Content-Type'] = contentType;
  } else if (!config.headers['Content-Type'] && ['POST', 'PUT', 'PATCH'].includes(method)) {
    config.headers['Content-Type'] = 'application/json';
  }

  // Perform the request with the final configuration
  const response = await axiosInstance.request<T>({
    method,
    url,
    data,
    ...config,
  });

  // Return the response data
  return response.data;
};

export default apiRequest;
